import Vue from 'vue';
import Tawk from 'vue-tawk';
import store from "@/store"
// required `appKey` param (tidio public key)
 
// available additional `delay` param
// to delay tidio script load (default: 0 ms)
if (store.getters.isNotTrustyCDN) {
  Vue.use(Tawk, { tawkSrc: 'https://embed.tawk.to/63871fa5daff0e1306da2fd6/1gj3t78dd' });
}
